import { Measurements } from '~/utility/BinSentry-ui-utility';
import { BnAction } from '../../common/bn-action';

class BinUpdateDimensions extends BnAction {
  constructor() {
    super();
    this.actionname = 'update-dimensions';
    this.successtext = 'Bin dimensions have been updated.';
    this.errortext = 'Failed to update bin dimensions.';
    this.submittext = 'Update';
    this.dimensionFields = [
      'dimensions[lipHeight]',
      'dimensions[deviceDepth]',
      'dimensions[top][truncatedRadius]',
      'dimensions[top][height]',
      'dimensions[body][radius]',
      'dimensions[body][height]',
      'dimensions[hopper][height]',
      'dimensions[hopper][truncatedRadius]',
    ];
  }

  preRender(action) {
    const measurement = Measurements.get('dimension');
    action.fields.forEach((field) => {
      if (this.dimensionFields.includes(field.name)) {
        if (!Object.keys(field).includes('originalValue')) {
          field.originalValue = field.value;
        }
        field.value = measurement.convert({ dimension: field.originalValue });
        field.suffix = measurement.unit;
      }
    });
  }

  preSubmit(fields) {
    const measurement = Measurements.get('dimension');
    for (const [key, val] of fields.entries()) {
      if (this.dimensionFields.includes(key)) {
        fields.set(key, measurement.reverse({ dimension: val }));
      }
    }
  }
}

window.customElements.define('bin-update-dimensions', BinUpdateDimensions);
